// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Vuex from 'vuex';
import {store, ability} from './store';
import {mapActions} from 'vuex';
import eventBus from './eventBus';
import axios from './axios';
import api from './api';
import Vuelidate from 'vuelidate'
import loaderMixin from '@/mixins/loader';
import formats from '@/mixins/formats'
import notificationsMixin from '@/mixins/notifications'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import moment from 'moment'
import Preloader from '@/components/Preloader';

import {library} from '@fortawesome/fontawesome-svg-core';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import filters from '@/mixins/filters';
import IdleVue from 'idle-vue';
import sessionExpiredModal from '@/mixins/sessionExpiredModal';

import { abilitiesPlugin, Can } from '@casl/vue'
//import VueConfirmDialog from 'vue-confirm-dialog';
import VueConfirmDialog from 'vue-confirm-dialog';

Vue.mixin(filters);

library.add(fas);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.prototype.$ls = localStorage;
Vue.prototype.$eventBus = eventBus;
Vue.prototype.moment = moment;

Vue.use(Vuex);
Vue.use(Vuelidate);
Vue.use(Notifications, {velocity});
Vue.use(VueConfirmDialog);
Vue.use(store);
Vue.mixin(api);
Vue.mixin(loaderMixin);
Vue.mixin(notificationsMixin);
Vue.mixin(formats);

const idleOptions = {
    eventEmitter: eventBus,
    idleTime: 1620000
    // idleTime: 2000
};
Vue.use(IdleVue, idleOptions);

Vue.use(abilitiesPlugin, ability);

Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('Preloader', Preloader);
Vue.component('Can', Can);

require('bootstrap');

global.$ = global.jQuery = require('jquery');


import {customJS} from '@/mixins/customJS';
import './scss/style.scss';

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    mixins: [sessionExpiredModal],
    template: '<App/>',
    methods: Object.assign({},
        mapActions([
            'setBaseUrl',
            'signIn',
            'signOut',
            'updateCountries',
            'updateCalcGaranties',
            'setTokenRefreshing',
            'updateUserInfo',
            'updateDrivingSchoolInfo',
        ]),
        {
            initAxios() {
                axios.interceptors.request.use((config) => {
                    if (config.method == 'get') {
                        if (!config.params) config.params = {};
                        config.params.one_time_password = this.$store.state.one_time_password;
                        config.params.pin = this.$store.state.pin_code;
                    } else {
                        if (!config.data) config.data = new FormData();
                        if (config.data instanceof FormData) {
                            config.data.append('one_time_password', this.$store.state.one_time_password);
                            config.data.append('pin', this.$store.state.pin_code);
                        }
                        else {
                            config.data.one_time_password = this.$store.state.one_time_password;
                            config.data.pin = this.$store.state.pin_code;
                        }
                    }

                    return config;
                });

                axios.interceptors.response.use((response) => {
                    return response;
                }, (error) => {

                    const originalRequest = error.config;

                    if (error.response.status === 401) {

                        if (this.isTokenRefreshing) {
                            return new Promise((resolve, reject) => {
                                this.$once('token-refreshed', token => {
                                    originalRequest.headers['Authorization'] = 'Bearer ' + token;
                                    axios(originalRequest).then(response => {
                                        resolve(response)
                                    });
                                })
                            });
                        }

                        this.$store.dispatch('setTokenRefreshing', true);

                        return axios.get(this.$store.state.baseUrl + '/api/auth/refresh?url=' + originalRequest.url + 'refresh=' + this.isTokenRefreshing, {
                            headers: originalRequest.headers
                        })
                            .then((response) => {
                                let token = response.data.access_token;
                                this.$ls.setItem('access_token', token);
                                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                                originalRequest.headers['Authorization'] = 'Bearer ' + token;
                                this.$store.dispatch('setTokenRefreshing', false);
                                this.$emit('token-refreshed', token);
                                return axios(originalRequest);
                            })
                            .catch(error => {
                                if (error.response.status === 403) {
                                    this.$store.dispatch('signOut');
                                } else {
                                    return Promise.reject(error);
                                }
                            });
                    }

                    if (error.response.status === 403 && error.response.data && error.response.data.error === 'g2fa_code_invalid') {
                        this.showErrorNotification('Incorrect code');
                    } else if (error.response.status === 403) {
                        this.$store.dispatch('signOut');
                    }

                    return Promise.reject(error);
                });

                return axios;
            },
            parseDomain() {
                let hrefs = window.location.href.match(/^(https?:\/\/)(?:[^.]*\.)?([^/]*)/);
                this.$store.dispatch('setBaseUrl', hrefs[1] + 'api.' + hrefs[2]);
            },
            logOut(callback = (callback) => {
                this.$store.dispatch('signOut');
            }, callbackError = (error) => {
                this.$store.dispatch('signOut');
            }) {
                this.apiPost('auth/logout').then(response => {
                    if (response.data.status === 'success') {
                        callback(response);
                    }
                }).catch(error => {
                    callbackError(error);
                })
            },
            clearObjectValues(obj) {
                Object.keys(obj).forEach(key => obj[key] = '');
            },
            normalizeDate(number) {
                number = number.toString();
                if (number.length < 2) number = '0' + number;
                return number;
            },
            parseValue(parsed_value, available_options, field_id = 'ID', field_name = 'NAME') {
                for (let value in available_options) {
                    if (available_options[value][field_id] === +parsed_value) return available_options[value][field_name];
                }
                return '';
            },
        },
    ),
    computed: {},
    created() {
        this.parseDomain();
    },
    mounted() {
        // let url = 'test_url';
        // this.apiGet(url);
        customJS();
    }
});



// WEBPACK FOOTER //
// ./src/main.js